import { render } from "./SearchComponent.vue?vue&type=template&id=89bda9cc&ts=true"
import script from "./SearchComponent?vue&type=script&lang=ts"
export * from "./SearchComponent?vue&type=script&lang=ts"

import "./assets/_Search.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/home/runner/work/xebel/xebel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__